import { render, staticRenderFns } from "./PortfolioHoldingsAreaStatic.vue?vue&type=template&id=41d44723&scoped=true&"
import script from "./PortfolioHoldingsAreaStatic.vue?vue&type=script&lang=js&"
export * from "./PortfolioHoldingsAreaStatic.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHoldingsAreaStatic.vue?vue&type=style&index=0&id=41d44723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d44723",
  null
  
)

export default component.exports